export default {
  '&DonationBanner.MonthlySuffix': '/mo',
  '&DonationBanner.CurrencySymbol': '$',
  '&DonationBanner.MonthlyGiftText': 'Repeat this gift monthly',
} as TextDictionary;
